
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { LanguageForm } from '@/components/forms/LanguageForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditLanguagePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const languageId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!languageId || Number.isNaN(languageId)) {
      navigate('/system-settings/language/languages', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [languageId, navigate])

  const handleSuccess = () => {
    navigate('/system-settings/language/languages')
  }

  const handleCancel = () => {
    navigate('/system-settings/language/languages')
  }

  if (isValidating || !languageId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Language</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update language information
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <LanguageForm languageId={languageId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

